export const duplicateItemRemover = (list: any[], key: string) => {
  return Array.from(new Map(list.map((obj: any) => [obj[key], obj])).values());
};
